exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Content___2QeJf {\n  width: 100%;\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.ErrorMessage___1LWbq {\n  margin: 0.5rem 0;\n  color: var(--color-dim);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.Row___1Veyi {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-flow: wrap;\n}\n\n.EmptyStateContainer___2OQbO {\n  text-align: center;\n}\n\n.Header___2vzMq {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"Content": "Content___2QeJf",
	"ErrorMessage": "ErrorMessage___1LWbq",
	"Row": "Row___1Veyi",
	"EmptyStateContainer": "EmptyStateContainer___2OQbO",
	"Header": "Header___2vzMq"
};